import { render, staticRenderFns } from "./AccountSidebarSelectElement.vue?vue&type=template&id=23e0e284&scoped=true&"
import script from "./AccountSidebarSelectElement.vue?vue&type=script&lang=js&"
export * from "./AccountSidebarSelectElement.vue?vue&type=script&lang=js&"
import style0 from "./AccountSidebarSelectElement.vue?vue&type=style&index=0&id=23e0e284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e0e284",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
